<template>
    <v-layout wrap align-center justify-center style="max-width: 500px; margin: 0 auto;"> 
        <v-flex xs12 >
          <div style="position: relative; width: 100%; padding-top: 75%;">
            <VueSignaturePad 
              style="position: absolute; top: 0; left: 0;"
              width="100%" 
              height="100%"
              :options="{backgroundColor: '#ffffff',onBegin: () => {$refs.signaturePad.resizeCanvas()},onEnd}" 
              ref="signaturePad"
              :customStyle=style
              />    
          </div>
        </v-flex>
        <!--v-flex xs3 offset-xs1>
            <div class="text-xs-center">
            <v-btn icon color="green" @click="save">
                <v-icon>mdi-check</v-icon>
            </v-btn>
            </div>
        </v-flex-->
        <v-flex xs3 offset-xs3> 
            <div class="text-xs-center">
            <v-btn icon color="orange" @click="undo">
                <v-icon>mdi-undo-variant</v-icon>
            </v-btn>  
            </div>
        </v-flex>
        <v-flex xs4 offset-xs2>
            <div class="text-xs-center">
            <v-btn icon color="red" @click="del">
                <v-icon>mdi-window-close</v-icon>
            </v-btn>  
            </div> 
        </v-flex>       
    </v-layout>   
</template>
<script>
export default {
  name: 'SignaturePad',
  props:{
    type: String
  },
  data () {
    return { 
      style :  {border: "black 1px solid"}
    }
  },
  methods: {    
    onEnd() {
      this.save();
    },
    del() {
      this.$refs.signaturePad.clearSignature();
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      //Guardamos la firma dependiendo de que dialog este abierto
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();      
      console.log(isEmpty);
      //console.log(data);
      /*if (this.$store.state.dialogSignature && !this.$store.state.dialogSignatureCustomer){
        this.$store.commit('saveSignature',data);
        //console.log('signatureOrder');
        //console.log(data);
      } else if (this.$store.state.dialogSignatureCustomer){
        this.$store.commit('saveSignatureCustomer',data);
      } else if (this.$store.state.dialogSignatureHourStart) {
        this.$store.commit('saveSignatureStart',data);
        //console.log('signatureStart');
        //console.log(data);
      } else if (this.$store.state.dialogSignatureHourEnd) {
        this.$store.commit('saveSignatureEnd',data);
        //console.log('signatureEnd');
        //console.log(data);
      }*/
      if (this.type == 'op'){
        this.$store.commit('saveSignature',data);
      } else if (this.type == 'cust'){
        this.$store.commit('saveSignatureCustomer',data);
      } else if (this.type == 'hourS'){
        this.$store.commit('saveSignatureStart',data);
      } else if (this.type == 'hourE'){
        this.$store.commit('saveSignatureEnd',data);
      } else if (this.type == 'serv'){
        this.$store.commit('saveSignatureServices',data);
      }
    }
  },
  computed:{
    dialogHourStart: {
      get(){
          return this.$store.state.dialogSignatureHourStart;
      },
      set(value){
          this.$store.state.dialogSignatureHourStart = value;
      }
    },  
    dialogHourEnd: {
      get(){
          return this.$store.state.dialogSignatureHourEnd;
      },
      set(value){
          this.$store.state.dialogSignatureHourEnd = value;
      }
    },
    dialogSignature: {
      get(){
          return this.$store.state.dialogSignature;
      },
      set(value){
          this.$store.state.dialogSignature = value;
      }
    },
  },
  watch: {    
    dialogSignature: function (val, oldval){
      if ((oldval == false) && (val == true)){
        this.$refs.signaturePad.clearSignature()
      }
    },
    dialogHourStart: function (val, oldval){
      if ((oldval == false) && (val == true)){
        this.$refs.signaturePad.clearSignature()
      }
    },
    dialogHourEnd: function (val, oldval){
      if ((oldval == false) && (val == true)){
        this.$refs.signaturePad.clearSignature()
      }
    }
    //Guardamos las firmas correspondientes cuando se cierren los formularios
    /*dialogSignature: function (val, oldval){
      if ((oldval == true) && (val == false)){
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        console.log(isEmpty);
        console.log('signatureOrder');
        console.log(data);
        this.$store.commit('saveSignature',data);
      }
    },    
    dialogHourStart: function (val, oldval){
      if ((oldval == true) && (val == false)){
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        console.log(isEmpty);
        console.log('signatureStart');
        console.log(data);
        this.$store.commit('saveSignatureStart',data);
      }
    },
    dialogHourEnd: function (val, oldval){
      if ((oldval == true) && (val == false)){
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        console.log(isEmpty);
        console.log('signatureEnd');
        console.log(data);
        this.$store.commit('saveSignatureEnd',data);
      }
    }*/
  }
};
</script>